/* @ngInject */
export default function AlertChipPatternDirective() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link($scope, $element, $attr, ngModel) {
            const ngPattern = ngModel.$validators.pattern;
            
            // Only override pattern validator if it exists
            if (ngPattern && typeof ngPattern === 'function') {
                ngModel.$validators.pattern = function(modelValue, viewValue) {
                    if (ngModel.$isEmpty(viewValue)) {
                        return true; // Empty values are valid for optional fields
                    }
                    
                    // Handle both array (chips) and single value cases
                    if (Array.isArray(viewValue)) {
                        // For chips - check each chip in the array
                        const invalidChips = viewValue.filter(chip => !ngPattern(modelValue, chip));
                        return invalidChips.length === 0;
                    }
                    // For single value - validate directly
                    return ngPattern(modelValue, viewValue);
                };
            }
        },
    };
};
